'use client';

import { createContext, useContext, useLayoutEffect, useMemo, useState, type ReactNode } from 'react';

type AppMarketingTakeoverContextValue = {
    isTakeoverActive: boolean;
    setTakeoverActive: (active: boolean) => void;
};

const AppMarketingTakeoverContext = createContext<AppMarketingTakeoverContextValue>({
    isTakeoverActive: false,
    setTakeoverActive: () => {}
});

export const AppMarketingTakeoverProvider = ({ children }: { children: ReactNode }) => {
    const [isTakeoverActive, setTakeoverActive] = useState(false);
    const value = useMemo(() => ({ isTakeoverActive, setTakeoverActive }), [isTakeoverActive]);

    return <AppMarketingTakeoverContext value={value}>{children}</AppMarketingTakeoverContext>;
};

export const useAppMarketingTakeover = (): AppMarketingTakeoverContextValue => useContext(AppMarketingTakeoverContext);

export const AppMarketingTakeoverRegistrar = () => {
    const { setTakeoverActive } = useAppMarketingTakeover();

    useLayoutEffect(() => {
        setTakeoverActive(true);

        return () => {
            setTakeoverActive(false);
        };
    }, [setTakeoverActive]);

    return null;
};
